import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getJournalOptions } from '@/module/Journal';
import { JournalEdit } from '@/module/Journal/JournalEdit';

export const Route = createFileRoute('/_auth/journal/_journal/$journalId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { journalId } = Route.useParams();
  const { data: journal } = useSuspenseQuery(getJournalOptions(journalId));

  return <JournalEdit journal={journal} />;
}
